/**
 * @description Smart Tag embed context - how Smart Tag is embedded
 * <p>INLINE - default Smart Tag embed mode - in the same DOM with parent application</p>
 * <p>IFRAME_MVP - MVP iframe - no scripting</p>
 * <p>IFRAME_SCRIPTED - scripted iframe</p>
 */
export enum EmbedContext {
	INLINE = 'EmbedContext.INLINE',
	IFRAME_MVP = 'EmbedContext.IFRAME_MVP',
	IFRAME_SCRIPTED = 'EmbedContext.IFRAME_SCRIPTED'
}